import { Component, OnInit, ViewChild } from '@angular/core';
import { ToolsService } from '../services/tools.service';
import { CentralBloqueiosService } from './central-bloqueios.service';
import {
  IBloqueio,
  IBloqueios,
  IDadosListaBloqueio,
} from './model/bloqueio.model';
import { AuthenticationService } from '../services/authentication.service';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from '../services/localstorage.service';
import { RegistroTransacoesService } from '../registro-transacoes/registro-transacoes.service';
import { IFiltroRegistroTransacoesViewModel } from '../relatorios/model/filtro-transacoes-view-model';
import { SnackBarService } from '../services/snack-bar-service.service';
import { MatDialog } from '@angular/material/dialog';
import { FiltroComponent } from '../registro-transacoes/filtro/filtro.component';
import { ListaBloqueiosComponent } from './lista-bloqueios/lista-bloqueios.component';
import { LIST_DASHBOARD } from './model/mock';
import { Router } from '@angular/router';
import { DetalheRegistroTransacaoComponent } from '../registro-transacoes/detalhe-registro-transacao/detalhe-registro-transacao.component';

@Component({
  selector: 'app-central-bloqueios',
  templateUrl: './central-bloqueios.component.html',
  styleUrls: ['./central-bloqueios.component.scss'],
})
export class CentralBloqueiosComponent implements OnInit {
  constructor(
    private toolsService: ToolsService<any>,
    private centralBloqueiosService: CentralBloqueiosService,
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    private registroTransacoesService: RegistroTransacoesService,
    private snackBar: SnackBarService,
    public dialog: MatDialog,
    private router: Router
  ) {
    this.usuario = this.registroTransacoesService?.usuario;
  }

  usuario!: LoginModel | undefined;
  loading: number = 0;
  loadingTransacoes: number = 0;
  firstLoad: number = 0;
  bloqueios: IBloqueio[] | undefined;
  tituloFuncionalidade: any = 'Central de bloqueios';

  //FILTRO INI
  @ViewChild(FiltroComponent) appFiltro!: any;
  filtro!: IFiltroRegistroTransacoesViewModel;
  //FILTRO END

  //DATATABLE INI
  public columns: any[] = [];
  public dataSource: any[] = [];
  public columnRowData: any = '';
  //DATATABLE END

  templateColunas = [
    {
      cmdName: 1,
      tituloRelatorio: 'Transações',
      filtro: [],
      colunas: [
        {
          columnDef: 'daT_ABASTECIMENTO',
          header: 'Data',
          format: null,
          multiValor: true,
          separador: 'br',
          campos: [
            {
              columnDef: '',
              campo: 'daT_ABASTECIMENTO',
              format: 'date',
              cssClass: '',
            },
            {
              columnDef: '',
              campo: 'daT_ABASTECIMENTO',
              format: 'time',
              cssClass: '',
            },
          ],
        },
        {
          columnDef: 'dsC_PLACA',
          header: 'Placa',
          format: null,
          multiValor: true,
          separador: 'br',
          campos: [
            { columnDef: '', campo: 'dsC_PLACA', format: null, cssClass: '' },
            {
              columnDef: '',
              campo: 'pB5_MODELO',
              format: null,
              cssClass: 'texto-menor',
            },
          ],
        },
        {
          columnDef: 'dsC_NOME',
          header: 'Motorista',
          format: null,
          multiValor: true,
          separador: 'br',
          campos: [
            { columnDef: '', campo: 'dsC_NOME', format: null, cssClass: '' },
            {
              columnDef: 'Cel: ',
              campo: 'nuM_CELULAR',
              format: null,
              cssClass: 'texto-menor',
            },
          ],
        },
        {
          columnDef: 'pA7_NREDUZ',
          header: 'Posto',
          format: null,
          multiValor: true,
          separador: 'br',
          campos: [
            { columnDef: '', campo: 'pA7_NREDUZ', format: null, cssClass: '' },
          ],
        },

        {
          columnDef: 'nM_CIDADE',
          header: 'Cidade',
          format: null,
        },
        {
          columnDef: 'cD_UF',
          header: 'UF',
          format: null,
        },
        { columnDef: 'zE_DESCRIC', header: 'Combustível', format: null },
        { columnDef: 'qtD_VOLUME', header: 'Litros', format: null },
        { columnDef: 'vlR_TOTAL', header: 'Valor Total', format: 'currency' },
        { columnDef: 'situacao', header: 'Status', format: null },
        { columnDef: 'dsC_MENSAGEM_RETORNO', header: 'Motivo', format: null },
        {
          columnDef: 'ACAO_DETALHES',
          header: 'Detalhes',
          tituloMenu: 'teste',
          format: null,
          orderBy: false,
          cssClass: 'menuAcao',
          actions: [
            {
              titulo: 'Ver mais',
              link: 'openDetalheTransacao',
              tipo: 'FUNCTION_ROW',
              cssClass: 'btnVermais',
              parametros: [{ nome: 'ROW', valor: 'ROW' }],
            },
          ],
        },
      ],
      columnDefinitions: {
        columnDef: 'ROW_COLOR',
        condition:
          "return row.situacao.toString() == 'Rejeitada' ? 'pintarLinhaTransacaoNegadas' : '';",
      },
    },
  ];

  async ngOnInit() {
    this.columns = this.configurarDadosTela();

    this.usuario = this.authenticationService.getDadosUserLocal();

    this.authenticationService
      .validate(this.registroTransacoesService?.usuario?.retorno?.guid ?? '')
      .then((dados) => {
        if (!dados.sucesso) {
          this.snackBar.flashMessage(
            this.authenticationService.msgSessaoExpirada,
            ['snackbar-error'],
            'Fechar',
            0
          );
          this.usuario = undefined;
        } else {
          this.atualizarDashBoard();
          this.filtrarTransacoes();
        }
      })
      .catch(() => {
        this.snackBar.flashMessage(
          this.authenticationService.msgSessaoExpirada,
          ['snackbar-error'],
          'Fechar',
          0
        );
      })
      .finally(() => {
        this.firstLoad++;
        //this.loading--;
      });
  }

  clickVerTransacoes() {
    this.router.navigate(['/registro-transacoes']);
  }

  private atualizarDashBoard() {
    
    this.loading++;
    const guid: any = this.usuario?.retorno.guid;
    let req = this.centralBloqueiosService.obterDashBoard({ guid: guid });

    req.subscribe({
      next: (res: IBloqueios) => {
        console.log(res);
        if (res?.sucesso) {
          this.bloqueios = res.retorno;
        }
      },
      complete: () => {
        this.loading--;
      },
    });
  }

  openDetalheTransacao(dados: any) {
    //console.log(dados);
    const dialogRef = this.dialog.open(DetalheRegistroTransacaoComponent, { width: '950px', height: '700px', data: dados });
  }


  public configurarDadosTela(): any[] {
    var retornoId = 1;
    //console.log(retornoId);
    var result = this.templateColunas.find(
      (template) => template.cmdName === retornoId
    );

    this.tituloFuncionalidade = result?.tituloRelatorio;
    if (result?.columnDefinitions) {
      this.columnRowData = result?.columnDefinitions;
    }

    return result ? result.colunas : [];
  }

  private filtrarTransacoes() {
    if (this.filtro == null) {
      this.filtro = this.appFiltro?.filtro;
    }

    //this.loadingTransacoes++;
    this.registroTransacoesService.obterListaTransacoes(this.filtro).subscribe({
      next: (res) => {
        if (res?.sucesso) {
          this.dataSource = (res.retorno as any[]).slice(0, 5);
        }
      },
      complete: () => {
        this.loadingTransacoes--;
      },
    });
  }

  public filtroIniciado(filtro: IFiltroRegistroTransacoesViewModel | null) {
    if (filtro != null) this.filtro = filtro;
  }

  public chamadaFiltro(filtro: IFiltroRegistroTransacoesViewModel | null) {
    if (filtro != null) this.filtro = filtro;

    this.filtrarTransacoes();
  }

  openDetalheBloqueioLista(dados: any, codTipoEntidade: number) {
    const dadosDialog: IDadosListaBloqueio = {
      titulo: dados.dscBloqueio,
      codTipoEntidadeBloqueio: codTipoEntidade,
      codBloqueioId: dados.codBloqueioId,
      listaBloqueios: dados.listaBloqueios,
    };
    console.log(dadosDialog);

    const dialogRef = this.dialog.open(ListaBloqueiosComponent, {
      width: '950px',
      height: '700px',
      data: dadosDialog,
    });
  }
}
